@if (showMenu) {
<div>
  @for (item of items; track getIdentifierForIterableItem($index, item)) {
  <div>
    <acs-menu-item [item]="item" (menuChanged)="registerToggle($event)"></acs-menu-item>
  </div>
  }
</div>
}
